var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePodcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.02222,
    y: 2.75531,
    width: 1.84296,
    height: 4.91489,
    rx: 0.921479,
    fill: "#E7DB9D",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.04517,
    y: 3.57449,
    width: 1.84296,
    height: 6.85105,
    rx: 0.921479,
    fill: "#E7DB9D",
    fillOpacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.14087,
    y: 6.3298,
    width: 1.84296,
    height: 4.91489,
    rx: 0.921479,
    fill: "#E7DB9D",
    fillOpacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.14087,
    y: 2.75531,
    width: 1.84296,
    height: 2.75532,
    rx: 0.921479,
    fill: "#E7DB9D",
    fillOpacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1636,
    y: 5.65955,
    width: 1.84296,
    height: 2.75532,
    rx: 0.921479,
    fill: "#E7DB9D",
    fillOpacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 5.65955,
    width: 1.84296,
    height: 2.75532,
    rx: 0.921479,
    fill: "#E7DB9D",
    fillOpacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.02222,
    y: 8.48938,
    width: 1.84296,
    height: 2.75532,
    rx: 0.921479,
    fill: "#E7DB9D",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.1189,
    y: 11.2447,
    width: 1.84296,
    height: 2.75532,
    rx: 0.921479,
    fill: "#E7DB9D",
    fillOpacity: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.1189,
    width: 1.84296,
    height: 2.75532,
    rx: 0.921479,
    fill: "#E7DB9D",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePodcast);
export default __webpack_public_path__ + "static/media/googlePodcast.056621fc119060b13171aed47c6252aa.svg";
export { ForwardRef as ReactComponent };